<template>
  <div>
    <bread-crumb></bread-crumb>
    <div class="export-box">
      <div class="title">导出问答信息：</div>
      <el-form ref="pgc-search-form" :model="form" label-width="90px" class="export-search">
        <el-form-item label="查询维度:">
          <el-select  v-model="form.type" placeholder="请选择查询维度" style="width: 200px" clearable>
            <el-option :label="'药品维度'" :value="1"></el-option>
            <el-option :label="'sku维度'" :value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="药品id:">
          <el-input style="width: 200px" v-model="form.drugId" placeholder="请输入药品id" clearable></el-input>
        </el-form-item>
        <el-form-item label="skuId:">
          <el-input style="width: 200px" v-model="form.skuId" placeholder="请输入skuId" clearable></el-input>
        </el-form-item>
        <el-form-item label="通用名:">
          <el-input style="width: 200px" v-model="form.genericName" placeholder="请输入通用名" clearable></el-input>
        </el-form-item>
        <el-form-item label="品牌名:">
          <el-input style="width: 200px" v-model="form.tradeName" placeholder="请输入品牌名" clearable></el-input>
        </el-form-item>
        <el-form-item label="类目:">
          <el-select  v-model="form.scope" placeholder="请选择类目" style="width: 200px" clearable>
            <el-option :label="'医药'" :value="1"></el-option>
            <el-option :label="'保健'" :value="2"></el-option>
            <el-option :label="'器械'" :value="3"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSumit">确认导出</el-button>
        </el-form-item>
      </el-form>
      <p>导出数据时间会根据数据量增加，建议合理添加筛选条件！！！</p>
    </div>
  </div>
</template>

<script>
import breadCrumb from "../../../../components/breadCrumb";
import { pgcExportQuestionAndAnswer } from '../../../../api/man.js';
export default {
  name: "pgcExport",
  components: {
    breadCrumb
  },
  data() {
    return {
      uploadShow: false,
      form: {
        type: '',
        drugId: '',
        genericName: '',
        tradeName: '',
        scope: '',
        skuId: ''
      }
    }
  },
  methods: {
    // 导出商品
    onSumit() {
      pgcExportQuestionAndAnswer({
        ...this.form,
      }).then(res => {
        console.log('res', res);
        if (res) {
          this.$message({
            message: '导出成功',
            type: 'success'
          })
          setTimeout(() => {
            this.$router.push({
              path: '/pgc/record'
            })
          }, 300);
        }
      })
    },
  }
}
</script>

<style lang="scss" scoped>
.export-box {
  padding: 20px 0 20px 33px;
  background: #fff;
  box-shadow: 0 0 6px rgba(229, 227, 227, 0.79);
  overflow: hidden;
  margin-top: 15px;

  .title {
    margin-bottom: 10px;
  }

  .export-search {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
  }

  p {
    color: red;
    font-size: 12px;
    margin-top: 5px;
  }

}
</style>
